import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { DefaultLookId, DefaultLookIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { AssetBundleFile, UploadAssetBundleRequest } from "./item/file"

export type CreateDefaultLookRequest = z.infer<typeof CreateDefaultLookRequest>
export const CreateDefaultLookRequest = z.object({
  name: z.string(),
  display_order: z.coerce.number().int(),
  thumbnailUploaded: z.boolean(),
})

export const UpdateDefaultLookRequest = z.object({
  name: z.string().optional(),
  updateThumbnail: z.boolean().optional(),
  display_order: z.coerce.number().int().optional(),
  uploadAssetBundle: UploadAssetBundleRequest.optional(),
})
export type UpdateDefaultLookRequest = z.infer<typeof UpdateDefaultLookRequest>

export const DefaultLookDocumentMeta = z.object({
  name: z.string().describe("表示名"),
  thumbnail: z.url().describe("サムネイル画像。`gs://` から始まる Firebase Storage の URL です。"),
  display_order: z.int().describe("表示優先度。数値が大きいほど先に表示する。"),
  asset_bundle: AssetBundleFile,
})

export type DefaultLookDocumentMeta = z.infer<typeof DefaultLookDocumentMeta>

export const DefaultLookDocumentBody = z.intersection(
  DefaultLookDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export const DefaultLookDocument = z.intersection(
  DefaultLookDocumentBody,
  z.object({
    id: DefaultLookIdSchema,
  })
)

export type DefaultLookDocument = z.infer<typeof DefaultLookDocument>

export class DefaultLookDocuments {

  static toDocumentData(doc: DefaultLookDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): DefaultLookDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: DefaultLookId(doc.id),
      name: data["name"],
      thumbnail: data["thumbnail"],
      display_order: data["display_order"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
      asset_bundle: data["asset_bundle"],
    }
  }
}
